import type { RunResult } from '@root/lib';
import type { HistoryRange } from '@shared/history';

// Only the three periods the design offers, not the shared chip set.
export const TIME_PERIODS: ReadonlyArray<{
  value: HistoryRange;
  label: string;
}> = [
  { value: 'D7', label: 'Last 7 days' },
  { value: 'D30', label: 'Last 30 days' },
  { value: 'ALL', label: 'All time' },
];

export type ResultFilter = 'ALL' | 'WON' | 'LOSS';

export const RESULT_OPTIONS: ReadonlyArray<{
  value: ResultFilter;
  label: string;
}> = [
  { value: 'ALL', label: 'All' },
  { value: 'WON', label: 'Win' },
  { value: 'LOSS', label: 'Loss' },
];

export function periodLabel(range: HistoryRange): string {
  return TIME_PERIODS.find((p) => p.value === range)?.label ?? 'All time';
}

export function resultLabel(filter: ResultFilter): string {
  return filter === 'ALL'
    ? 'All results'
    : (RESULT_OPTIONS.find((o) => o.value === filter)?.label ?? 'All results');
}

// A run is a loss however it ended — eliminated, given up or expired.
export function matchesResult(
  result: RunResult,
  filter: ResultFilter
): boolean {
  if (filter === 'ALL') return true;
  if (filter === 'WON') return result === 'WON';
  return (
    result === 'ELIMINATED' || result === 'ABANDONED' || result === 'EXPIRED'
  );
}
